/**
 * English — the fallback language, and the shape `TranslationKey` is derived
 * from. Statically imported by `i18n/index.ts`: i18next needs it whatever the
 * user picked, so deferring it would buy nothing and cost the compile-time key
 * check across the app.
 */
import base from "../en.json";
import account from "../account/en.json";
import auth from "../auth/en.json";
import billing from "../billing/en.json";
import business from "../business/en.json";
import growth from "../growth/en.json";
import help from "../help/en.json";
import home from "../home/en.json";
import language from "../language/en.json";
import location from "../location/en.json";
import onboarding from "../onboarding/en.json";
import options from "../options/en.json";
import practice from "../practice/en.json";
import profile from "../profile/en.json";
import referral from "../referral/en.json";
import social from "../social/en.json";

export default {
  ...base,
  account,
  auth,
  billing,
  business,
  growth,
  help,
  home,
  language,
  location,
  onboarding,
  options,
  practice,
  profile,
  referral,
  social,
};
